import ParsingShop from './ParsingShop'
import WithParsing from 'containers/WithParsing'

export default WithParsing(ParsingShop)
